import React, { useEffect, useState } from "react";
import { MainContainer } from "../../../content/content.element";
import { Box, Typography } from "@mui/material";
import BasicTabs from "../../../Tabs/TabsMain";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ReferedStudentTable from "./ReferedStudentTable";
import WithdrawalHistoryTable from "./WithdrawalHistoryTable";
import { useDispatch, useSelector } from "react-redux";
import { referalWithdrawDetailsAction } from "../../../../actions/referAndEarn/referAndEarnActions";

function WithDrawalDetailsMain(props) {
  const naviagte = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  let { referalDetailsSuccess } = useSelector((state) => state.referalDetails);

  const [userData, setUserData] = useState();
  const [referedStudentData, setReferedStudent] = useState();
  const [withdrawalHistoryData, setWithdrawalHistory] = useState();

  useEffect(() => {
    dispatch(referalWithdrawDetailsAction(id));
  }, [id]);
  useEffect(() => {
    if (referalDetailsSuccess) {
      setUserData(referalDetailsSuccess.data);
      setReferedStudent(referalDetailsSuccess.referredStudents);
      setWithdrawalHistory(referalDetailsSuccess.withdrawals);
    }
  }, [referalDetailsSuccess]);

  return (
    <MainContainer active={props.toggle}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          py: "24px",
          borderBottom: "1px solid #ECECEC",
          mb: "32px",
        }}
      >
        <ArrowBackIcon
          onClick={() => naviagte(-1)}
          sx={{
            cursor: "pointer",
          }}
        />
        <Typography
          sx={{
            color: "#05050F",
            fontSize: "24px",
            lineHeight: "24px",
            fontWeight: "700",
          }}
        >
          Earn Details
        </Typography>
      </Box>
      <Box
        sx={{
          border: "1px solid #ECECEC",
          padding: "20px",
          borderRadius: "4px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: "20px",
            justifyContent: "space-between",
            maxWidth: "1000px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <Box
              sx={{
                width: "120px",
                height: "120px",
                borderRadius: "50%",
                overflow: "hidden",
                "& img": {
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                },
              }}
            >
              <img
                src={
                  userData?.lead?.imgUrl
                    ? userData?.lead?.imgUrl
                    : "/avatar.png"
                }
                alt="profile image"
              />
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: "23px",
                  fontWeight: "700",
                  color: "#000000",
                }}
              >
                {userData?.lead?.firstName + " " + userData?.lead?.lastName}
              </Typography>
              <Typography
                sx={{
                  fontSize: "18px",
                  color: "#000000",
                }}
              >
                Student
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              width: "1px",
              backgroundColor: "#ECECEC",
            }}
          ></Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                }}
              >
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.26036 11.1357C4.83848 13.0222 6.73818 14.5075 8.90644 15.5584C9.73197 15.9496 10.836 16.4138 12.066 16.4934C12.1422 16.4967 12.2152 16.5 12.2914 16.5C13.117 16.5 13.78 16.2149 14.3204 15.6281C14.3238 15.6247 14.3304 15.6181 14.3337 15.6115C14.526 15.3794 14.7448 15.1705 14.9736 14.9484C15.1294 14.7992 15.2885 14.6434 15.441 14.4843C16.1472 13.7482 16.1472 12.8133 15.4344 12.1005L13.4419 10.108C13.1037 9.75653 12.6992 9.57087 12.2749 9.57087C11.8505 9.57087 11.4427 9.75653 11.0946 10.1046L9.90768 11.2915C9.79828 11.2286 9.68555 11.1722 9.57946 11.1191C9.44685 11.0528 9.32418 10.9898 9.21477 10.9202C8.13396 10.2339 7.15261 9.33879 6.21436 8.18835C5.74026 7.58827 5.42198 7.08433 5.19985 6.57045C5.5115 6.28864 5.80325 5.99358 6.08506 5.70514C6.18452 5.60236 6.28729 5.49959 6.39007 5.39681C6.74813 5.03875 6.94042 4.62433 6.94042 4.20327C6.94042 3.78222 6.75145 3.3678 6.39007 3.00974L5.40209 2.02176C5.28605 1.90572 5.17664 1.793 5.06392 1.67696C4.84511 1.45151 4.61634 1.21944 4.3909 1.01057C4.04942 0.675715 3.64826 0.5 3.22389 0.5C2.80284 0.5 2.39836 0.675715 2.04361 1.01388L0.803664 2.25383C0.352773 2.70472 0.0974891 3.25176 0.0444431 3.885C-0.0185491 4.67737 0.127327 5.51948 0.50528 6.5373C1.08547 8.1121 1.96073 9.57418 3.26036 11.1357ZM0.853395 3.95462C0.893179 3.51368 1.06226 3.14567 1.38054 2.82739L2.61386 1.59407C2.80615 1.40841 3.01833 1.31227 3.22389 1.31227C3.42613 1.31227 3.63168 1.40841 3.82066 1.6007C4.04279 1.80626 4.25165 2.02176 4.4771 2.25052C4.58982 2.36656 4.70586 2.48259 4.8219 2.60195L5.80988 3.58993C6.01543 3.79548 6.12153 4.00435 6.12153 4.2099C6.12153 4.41546 6.01543 4.62433 5.80988 4.82988C5.7071 4.93266 5.60433 5.03875 5.50155 5.14152C5.19322 5.45317 4.90478 5.74824 4.58651 6.03005C4.57988 6.03668 4.57656 6.03999 4.56993 6.04662C4.29475 6.3218 4.33785 6.58371 4.40416 6.78264C4.40748 6.79258 4.41079 6.79921 4.41411 6.80916C4.66939 7.4225 5.02414 8.00601 5.5778 8.70224C6.57242 9.92893 7.62007 10.8804 8.77383 11.6131C8.91639 11.706 9.06889 11.7789 9.21145 11.8518C9.34407 11.9182 9.46674 11.9811 9.57615 12.0508C9.58941 12.0574 9.59935 12.064 9.61261 12.0707C9.72202 12.127 9.82811 12.1535 9.93421 12.1535C10.1994 12.1535 10.3718 11.9845 10.4282 11.9281L11.6681 10.6881C11.8604 10.4959 12.0693 10.3931 12.2749 10.3931C12.5268 10.3931 12.7324 10.5489 12.8617 10.6881L14.8609 12.684C15.2587 13.0818 15.2554 13.5128 14.8509 13.9339C14.7117 14.0831 14.5658 14.2257 14.41 14.3748C14.1779 14.6003 13.9359 14.8324 13.717 15.0943C13.3358 15.5054 12.8816 15.6977 12.2948 15.6977C12.2384 15.6977 12.1787 15.6944 12.1224 15.691C11.0349 15.6214 10.0237 15.1971 9.2645 14.8357C7.20234 13.8378 5.39214 12.4221 3.89028 10.6252C2.65364 9.13655 1.82148 7.75072 1.27113 6.26544C0.929648 5.35371 0.800349 4.62101 0.853395 3.95462Z"
                    fill="black"
                  />
                </svg>
                <Typography
                  sx={{
                    color: "#000000",
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                >
                  {userData?.lead?.mobileNumber
                    ? userData?.lead?.countryId +
                      " " +
                      userData?.lead?.mobileNumber
                    : "-"}
                </Typography>
              </Box>
              <Typography
                sx={{
                  color: "#000000",
                  fontSize: "14px",
                  lineHeight: "24px",
                }}
              >
                Bank Name:{" "}
                <Typography
                  component={"span"}
                  sx={{
                    color: "#777777",
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                >
                  {userData?.BankName ? userData?.BankName : "-"}
                </Typography>
              </Typography>
            </Box>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                }}
              >
                <svg
                  width="16"
                  height="13"
                  viewBox="0 0 16 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.5938 0.875H1.40625C0.632438 0.875 0 1.50466 0 2.28125V10.7188C0 11.4956 0.632844 12.125 1.40625 12.125H14.5938C15.3676 12.125 16 11.4953 16 10.7188V2.28125C16 1.50447 15.3673 0.875 14.5938 0.875ZM14.3778 1.8125C13.9232 2.26866 8.58266 7.62656 8.36325 7.84669C8.18 8.0305 7.82009 8.03062 7.63675 7.84669L1.62219 1.8125H14.3778ZM0.9375 10.5464V2.45359L4.97078 6.5L0.9375 10.5464ZM1.62219 11.1875L5.63263 7.164L6.97278 8.50853C7.52197 9.0595 8.47825 9.05928 9.02725 8.50853L10.3674 7.16403L14.3778 11.1875H1.62219ZM15.0625 10.5464L11.0292 6.5L15.0625 2.45359V10.5464Z"
                    fill="black"
                  />
                </svg>

                <Typography
                  sx={{
                    color: "#000000",
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                >
                  {userData?.lead?.email ? userData?.lead?.email : "-"}
                </Typography>
              </Box>
              <Typography
                sx={{
                  color: "#000000",
                  fontSize: "14px",
                  lineHeight: "24px",
                }}
              >
                IFSC Code:{" "}
                <Typography
                  component={"span"}
                  sx={{
                    color: "#777777",
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                >
                  {userData?.ifsc}
                </Typography>
              </Typography>
            </Box>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                }}
              >
                <svg
                  width="12"
                  height="17"
                  viewBox="0 0 12 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 16.0312C4.125 13.2187 0.84375 9.40625 0.84375 6.125C0.84375 3.28184 3.15684 0.968745 6 0.968745C8.84316 0.968745 11.1562 3.28184 11.1562 6.125C11.1562 9.40625 7.875 13.2187 6 16.0312Z"
                    stroke="black"
                    stroke-width="0.9375"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6 8.46875C4.70772 8.46875 3.65625 7.41728 3.65625 6.125C3.65625 4.83272 4.70772 3.78125 6 3.78125C7.29228 3.78125 8.34375 4.83272 8.34375 6.125C8.34375 7.41728 7.29228 8.46875 6 8.46875Z"
                    stroke="black"
                    stroke-width="0.9375"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <Typography
                  sx={{
                    color: "#000000",
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                >
                  {userData?.lead?.livingCountry
                    ? userData?.lead?.livingCountry
                    : "-"}
                </Typography>
              </Box>
              <Typography
                sx={{
                  color: "#000000",
                  fontSize: "14px",
                  lineHeight: "24px",
                }}
              >
                Account Number:
                <Typography
                  component={"span"}
                  sx={{
                    color: "#777777",
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                >
                  {" "}
                  {userData?.AccountNumber ? userData?.AccountNumber : " -"}
                </Typography>
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      <BasicTabs
        tab1={<ReferedStudentTable data={referedStudentData} />}
        tab2={<WithdrawalHistoryTable data={withdrawalHistoryData} />}
        tab1Name="Referred Students"
        tab2Name="Withdrawal History"
      />
    </MainContainer>
  );
}

export default WithDrawalDetailsMain;
